module.exports = __webpack_public_path__ + "img/03-dark.1520775c.png";